import React, { useEffect, useState } from 'react';
import { getAllChallenges } from '../../services/api/challenges/getChallenge';

const Select = ({ handleReturnValue=()=>{}}) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');

  // Fetch options from API
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await getAllChallenges(1); // Replace with your API endpoint
        setOptions(response.data.map((res) => ({ id:res.challenge_id, title:res.title})));
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    };

    fetchOptions();
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    const combo = value.split('|');
    setSelectedOption(combo[1]);
    handleReturnValue(combo[0],combo[1]);
  };

  return (
    <div className="">
      <label className="block text-sm font-medium text-gray-700 mb-2">Select an Option:</label>
      <select
        value={selectedOption}
        onChange={handleChange}
        className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="" disabled>
          Choose an option
        </option>
        {options.map((option) => (
          <option key={option.id} value={`${option.id}|${option.title}`}>
            {option.title}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
